// extracted by mini-css-extract-plugin
export var component = "TextContent-module--component--I1Ox9";
export var isCompact = "TextContent-module--isCompact--4c0HW";